import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { FinancialBalanceFigures } from "web_myplann/Dashboard/Components/FinancialBalanceFigures";
import { FinancialBalanceTip } from "web_myplann/Dashboard/Components/FinancialBalanceTip";

type Props = {
	income: number;
	expense: number;
	balance: number;
	onClick: () => void;
};

export const FinancialBalanceSummaryCard: FC<Props> = ({
	income,
	expense,
	balance,
	onClick,
}) => {
	const theme = useTheme();

	return (
		<Stack
			gap={theme.spacingTokens.md}
			p={theme.spacingTokens.lg}
			bgcolor={theme.palette.background.paper}
			borderRadius={theme.radii.lg}
		>
			<FinancialBalanceFigures
				income={income}
				expense={expense}
				balance={balance}
				onClick={onClick}
			/>
			<FinancialBalanceTip
				income={income}
				expense={expense}
				balance={balance}
			/>
		</Stack>
	);
};
